import { breakpointsTailwind, useBreakpoints as vueUseBreakpoints } from '@vueuse/core'

export function useBreakpoints<K extends string = string>(
  ...params: Parameters<typeof vueUseBreakpoints<K>> extends [unknown, ...infer Rest] ? Rest : never
) {
  return vueUseBreakpoints(...[breakpointsTailwind, ...params])
}
